$(document).ready( function(){
	if ($('#mobilenav').length > 0){
		if( $(window).width() < 550 ) {

		    $('#mobilenav').click( function(){
		    	$('header nav ul').toggle();
		    });
		}
	}
});